module.exports = __webpack_public_path__ + "static/media/Vaishnavi_Badgujar.b595f99e.jpg";